/**
 * Abspielen von Animationen bei Benutzer-Aktionen
 * @class service_v3sInteractionService
 * @memberOf v3sWbtPlayerApp:animation
 */
angular.module('v3sWbtPlayerApp').factory('v3sInteractionService', ["v3sAnimationService", "v3sTimelineService", "v3sBrowserInfoService", "v3sLinkService", function (v3sAnimationService, v3sTimelineService, v3sBrowserInfoService, v3sLinkService) {

    var actions;
    var elements;
    var isMobile = v3sBrowserInfoService.isIosBrowser() || v3sBrowserInfoService.isIosWebApp() || v3sBrowserInfoService.isIosAppViversa() || navigator.userAgent.match(/Android/i) !== null || v3sBrowserInfoService.isTouchBrowser();

    /**
   * Initialisiert die Interaktionen
   * @memberOf v3sWbtPlayerApp:animation.service_v3sInteractionService
   */
    function init() {
        actions = {};
        elements = [];
    }

    /**
   * Fügt auf Events horchendes Element hinzu
   * @memberOf v3sWbtPlayerApp:animation.service_v3sInteractionService
   * @param {Object} element - Nachricht
   */
    function addElement(element) {
        var id = element[0].id;
        var mouseEnterActionTriggered = false;
        var mouseLeaveActionTriggered = false;
        var mouseClickActionTriggered = false;
        var target = false;

        if (!!actions[id]) {
            var hasMouseenter = !!actions[id].mouseenter;
            var hasMouseleave = !!actions[id].mouseleave;
            elements.push(element);

            if (!!actions[id].click) {
                element.addClass("clickable");
                element.bind('click', function (evt) {
                    if (isMobile && hasMouseenter) {
                        target = element;
                        if (hasMouseenter && !mouseEnterActionTriggered) {
                            triggerMouseEnterActions(id);
                            mouseEnterActionTriggered = true;
                        } else if (mouseEnterActionTriggered && !mouseClickActionTriggered) {
                            triggerClickActions(id);
                            mouseClickActionTriggered = true;
                        } else if (mouseEnterActionTriggered && mouseClickActionTriggered) {
                            triggerMouseLeaveActions(id);
                            mouseEnterActionTriggered = mouseClickActionTriggered = false;
                        }
                    } else {
                        triggerClickActions(id)
                    }
                    evt.stopPropagation();
                });
            } else if (!!actions[id].mouseenter && isMobile) {
                element.bind('click', function (evt) {
                    triggerMouseEnterActions(id);
                    mouseEnterActionTriggered = true;
                })
            }

            //Touch -> TODO
            if (!isMobile) {
                if (!!actions[id].mouseenter) {
                    element.on('mouseenter', function () {
                        angular.forEach(actions[id].mouseenter, function (action) {
                            v3sTimelineService.addAsyncAction(action);
                        });
                    });
                }

                if (!!actions[id].mouseleave) {
                    element.on('mouseleave', function () {
                        angular.forEach(actions[id].mouseleave, function (action) {
                            v3sTimelineService.addAsyncAction(action);
                        });
                    });
                }
            } else {
                if (hasMouseleave) {
                    angular.element(document.querySelector("body")).on("click", function (evt) {
                        if (mouseEnterActionTriggered) {
                            triggerMouseLeaveActions(id);
                            mouseEnterActionTriggered = false;
                        }
                    })
                }
            }
        }



    }

    /**
    * Ordnet die Aktionen dem horchenden Element zu
    * @memberOf v3sWbtPlayerApp:animation.service_v3sInteractionService
    * @param {Object} action - Aktion
    */
    function addAction(action) {
        var id = action.actor;
        var event = action.event;
        if (!!id && !!event) {

            if (!actions[id]) {
                actions[id] = {};
            }

            if (!actions[id][event]) {
                actions[id][event] = [];
            }

            actions[id][event].push(action);
        }
    }

    /**
    * Stoppt alle Animationen und räumt auf
    * @memberOf v3sWbtPlayerApp:animation.service_v3sInteractionService
    */
    function destroy() {
        v3sAnimationService.killTweensOf(elements);
        actions = null;
        elements = null;
    }


    /**
     * Hilfsfunktionen
     */


    /**
     * triggered die Click actions
     * @param id - id des actors
     */
    function triggerClickActions(id) {
        angular.forEach(actions[id].click, function (action) {
            // Links direkt öffnen, um Popup-Blocker zu umgehen

            //Testen, ob der Link zu einem Item im WBT führt
            var linkToWbtPage = null;
            if (action.command === "jumpTo") {
                linkToWbt = !!v3sLinkService.findItem(action.href);
            }

            var useTimeline = (!(action.command == "jumpTo" && linkToWbtPage) && action.command !== "doZertPrint" && action.command !== "mailPage");

            if (useTimeline) {
                v3sTimelineService.addAsyncAction(action);
            } else {
                v3sAnimationService.createTween(action, true);
            }
        });
    }

    /**
    * triggered die MouseEnter actions
    * @param id - id des actors
    */
    function triggerMouseEnterActions(id) {
        angular.forEach(actions[id].mouseenter, function (action) {
            v3sTimelineService.addAsyncAction(action);
        });
    }

    /**
    * triggered die MouseLeave actions
    * @param id - id des actors
    */
    function triggerMouseLeaveActions(id) {
        angular.forEach(actions[id].mouseleave, function (action) {
            v3sTimelineService.addAsyncAction(action);
        });
    }


    /**
     * findet heraus, ob das geklickte element ein kindelement von dem actor ist
     * @param el - das geklickte element
     */

    function isChildOfActorElement(el,id) {
        while (el.tagName.toLowerCase() != "v3s-document" && el.id != id) {
            el = el.parentElement;
        }

        return el.id == id;
    }

    return {
        init: init,
        addElement: addElement,
        addAction: addAction,
        destroy: destroy
    };

}]);
